<template>
    <div class="fw-msfx">
        <van-nav-bar :title="title" style="background-color: #CCD5E6;" left-text="" @click-left="onClickLeft" left-arrow
                     :fixed="true">
        </van-nav-bar>
        <div class="sousuo">
            <div class="sou-item">
                <span class="sou-name">门店</span>
                <el-select v-model="mdId" placeholder="选择门店" class="sou-val" size="mini">
                    <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.deptName"
                            :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <div class="sou-item">
                <span class="sou-name">搜索</span>
                <el-select v-model="goodsId" placeholder="选择商品" class="sou-val" size="mini">
                    <el-option
                            v-for="item in mss"
                            :key="item.id"
                            :label="item.goodsName"
                            :value="item.id">
                    </el-option>
                </el-select>
            </div>
        </div>
        <Cxdate @chaxun="chaxun"/>
        <div class="msfx">
            <div class="msfx-item">
                <div class="msfx-item-bt">
                    <span>成交统计</span>
                </div>
                <div class="msfx-nr">
                    <div class="nr-item">
                        <span>商品订单数量</span>
                        <span>{{ms.orderNum}}</span>
                    </div>
                    <div class="nr-item">
                        <span>成交金额</span>
                        <span>{{ms.totalPrice}}</span>
                    </div>
                    <div class="nr-item">
                        <span>核销</span>
                        <span>{{ms.mshxNum}}</span>
                    </div>
                    <div class="nr-item">
                        <span>核销门店业绩</span>
                        <span>{{ms.mshxAch}}</span>
                    </div>
                    <div class="nr-item">
                        <span>请客卡数量</span>
                        <span>{{ms.qkkNum}}</span>
                    </div>
                    <div class="nr-item">
                        <span>已领取</span>
                        <span>{{ms.qkklqNum}}</span>
                    </div>
                    <div class="nr-item">
                        <span>到店核销数量</span>
                        <span>{{ms.qkkhxAch}}</span>
                    </div>
                </div>
            </div>
            <div class="msfx-item">
                <div class="msfx-item-bt">
                    <span>访问分析</span>
                </div>
                <div class="msfx-nr1">
                    <div class="nr-item1">
                        <span>{{ms.fwl}}</span>
                        <span>总访问量</span>
                    </div>
                </div>
            </div>
            <div class="msfx-item">
                <div class="msfx-item-bt">
                    <span>销售员收益分析</span>
                </div>
                <div class="msfx-nr1">
                    <div class="nr-item1">
                        <span>{{ms.zjxsCmn}}</span>
                        <span>直接销售提成</span>
                    </div>
                    <div class="nr-item1">
                        <span>{{ms.jjBonus}}</span>
                        <span>间接奖金</span>
                    </div>
                    <div class="nr-item1">
                        <span>{{ms.bmBonus}}</span>
                        <span>部门奖金</span>
                    </div>
                    <div class="nr-item1">
                        <span>0</span>
                        <span>伯乐奖金</span>
                    </div>
                    <div class="nr-item1">
                        <span>0</span>
                        <span>平级奖金</span>
                    </div>
                    <div class="nr-item1">
                        <span>0</span>
                        <span>帮扶奖金</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getCookie} from "../../../utils/auth";
    import Cxdate from "./../../common/cxdate.vue";

    export default {
        components: {Cxdate},
        data() {
            return {
                title: '秒杀分析',
                fwUser: {},
                deptId: '',
                goodsId: '',
                token: '',
                userType: '',
                dateType: 0,
                staDate: '',
                endDate: '',

                name: '',
                mdId: '',
                cxType: 'DAN',

                depts: [],
                mss: [],
                ms: {},
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            this.userType = this.fwUser.userType
            await this.getDepts()
            await this.getMss()
            await this.onLoad()
        },
        methods: {
            chaxun(data) {
                this.dateType = data.dateType
                this.staDate = data.staDate
                this.endDate = data.endDate
                this.list = []
                this.onLoad()
            },

            async getDepts() {
                let data = {
                    token: this.token
                }
                let res = await this.$get("/fw/getFwDepts", data)
                this.depts = res.list
                this.cxType = res.cxType
                if (this.depts.length > 0) {
                    this.mdId = this.depts[0].id
                }
            },
            async getMss() {
                let data = {
                    token: this.token
                }
                let res = await this.$get("/fw/getFwGoodsList", data)
                this.mss = res.list
            },

            async onLoad() {
                let data = {
                    token: this.token,
                    dateType: this.dateType,
                    staDate: this.staDate,
                    endDate: this.endDate,
                    cxType: this.cxType,
                    name: this.name,
                    mdId: this.mdId,
                    goodsId: this.goodsId,
                }
                let res = await this.$get("/fw/getFwMsAnalysis", data)
                this.ms = res.ms
            },

            onClickLeft() {
                this.$router.go(-1)
            },
        },
    };
</script>

<style lang="scss" scoped>
    .fw-msfx {
        margin: 0 auto;
        height: 100%;
        position: relative;
        overflow: scroll;
        padding-top: 46px;
        padding-bottom: 49px;
        background-color: #F3F2F7;
    }

    .sousuo {
        background-color: #FFFFFF;
        padding-top: 10px;
    }

    .sou-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 13px;
        height: 38px;
    }

    .sou-name {
        width: 80px;
        text-align: right;
        margin-right: 8px;
    }

    .sou-val {
        width: 60%;
    }

    .msfx {

    }

    .msfx-item {
        margin: 10px;
        background-color: #FFFFFF;
        padding: 8px;
    }

    .msfx-item-bt {
        border-bottom: #EEEEEE solid 1px;
        font-size: 13px;
        padding-top: 8px;
        padding-bottom: 7px;
    }

    .msfx-item-bt span {
        border-left: #2b94ff solid 3px;
        padding-left: 5px;
    }

    .msfx-nr {
        display: flex;
        flex-flow: row wrap;
        padding-top: 10px;
    }

    .nr-item {
        flex: 1;
        box-sizing: border-box;
        padding: 5px;
        margin-bottom: 16px;
        display: flex;
        flex-direction: column;
        font-size: 11px;
        width: calc(100% / 4); // 我这里一行显示4个 所以是/4  一行显示几个就除以几
        min-width: calc(100% / 4);
        max-width: calc(100% / 4);

        &:nth-child(4n + 4) {
            margin-right: 0;
        }
    }

    .nr-item span {
        text-align: center;
        height: 28px;
        line-height: 28px;
    }

    .msfx-nr1 {
        display: flex;
        flex-flow: row wrap;
        padding-top: 10px;
    }

    .nr-item1 {
        flex: 1;
        box-sizing: border-box;
        padding: 5px;
        margin-bottom: 16px;
        display: flex;
        flex-direction: column;
        font-size: 11px;
        width: calc(100% / 3); // 我这里一行显示4个 所以是/4  一行显示几个就除以几
        min-width: calc(100% / 3);
        max-width: calc(100% / 3);

        &:nth-child(3n + 3) {
            margin-right: 0;
        }
    }

    .nr-item1 span {
        text-align: center;
        height: 28px;
        line-height: 28px;
    }


</style>